import styled from 'styled-components';

export const IconAnchor = styled.a`
  display: inline-flex;
  align-items: center;

  svg {
    width: 1em;
    height: 1em;

    path {
      fill: currentColor;
    }
  }
`;
